<template>
    <div>
        <l-card-headline>
            {{ greeting }}<template v-if="user.firstname">, {{ user.firstname }}!</template>
            <img
                src="@/img/icons/hand_small.png"
                alt=""
                class="tw-w-8 tw-ml-2 tw-opacity-75"
                loading="lazy"
            />
        </l-card-headline>

        <l-tab-navigation :tabs="tabs" :selected.sync="selectedTab">
            <a
                v-if="user.rights.A_PAYM && user.trialEnd"
                href="#/team/settings/billing"
                class="tw-font-bold"
            >
                <i class="fal fa-calendar tw-mr-1" />
                {{ $t("profile.notif.trial", [user.trialEnd]) }}
            </a>
        </l-tab-navigation>

        <div>
            <l-skeleton-loader v-if="isLoading" />

            <div
                v-if="selectedTab.id === 'news' && !groupedNotifications.news.length"
                class="tw-text-center tw-text-gray-400"
            >
                <img
                    src="@/img/icons/meetings.png"
                    alt=""
                    class="tw-h-28 tw-opacity-75"
                    loading="lazy"
                />
                <div class="tw-mt-4">
                    <template>
                        {{ $t("profile.notif.empty") }}
                    </template>
                </div>
            </div>

            <div v-else-if="selectedTab.id === 'actionItems'">
                <div v-if="!actionItems.length" class="tw-text-gray-400">
                    {{ $t("profile.meetings.emptyActionItems") }}
                </div>
                <l-meetings-action-items-list v-else :action-items="actionItems" />
            </div>

            <l-notifications-list
                v-else
                :notifications="groupedNotifications[selectedTab.id]"
                :is-visitor="false"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardHeadline from "@/components/LCardHeadline";
import LTabNavigation from "@/components/LTabNavigation";
import LSkeletonLoader from "@/components/LSkeletonLoader";
import LNotificationsList from "@/components/LUserProfile/LNotificationsList";
import LMeetingsActionItemsList from "@/components/LUserProfile/LMeetingsActionItemsList";

export default {
    components: {
        LCardHeadline,
        LTabNavigation,
        LSkeletonLoader,
        LNotificationsList,
        LMeetingsActionItemsList,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            selectedTab: {
                id: "todo",
            },
        };
    },
    computed: {
        ...mapGetters({
            notifications: "notifications/profilePreview/notifications",
            actionItems: "meetings/meetings/actionItems",
        }),
        tabs() {
            return [
                {
                    id: "todo",
                    label: `${this.$t("profile.notif.sortToDo")} (${this.groupedNotifications?.todo
                        ?.length || 0})`,
                    visible: this.groupedNotifications?.todo?.length > 0,
                    testId: "tab-todo",
                },
                {
                    id: "news",
                    label: this.$t("profile.notif.sortDate"),
                    testId: "tab-news",
                },
                {
                    id: "actionItems",
                    label: `${this.$t("profile.notif.actionItems")} (${this.actionItems?.length ||
                        0})`,
                    testId: "tab-action-items",
                    visible: this.user.rights.S_VIEW || this.user.rights.M_VIEW,
                },
            ];
        },
        greeting() {
            const currentHour = new Date().getHours();

            if (currentHour > 2 && currentHour < 11) return this.$t("profile.greetingMorning");
            else if (currentHour < 17) return this.$t("profile.greetingDay");
            else return this.$t("profile.greetingEvening");
        },
        groupedNotifications() {
            const groupedNotifications = {
                todo: [],
                news: [],
            };

            if (!Array.isArray(this.notifications)) return groupedNotifications;

            groupedNotifications.todo = this.notifications.filter(
                notification => notification.accessingUserToDo,
            );
            groupedNotifications.news = this.notifications.filter(
                notification => !notification.accessingUserToDo,
            );

            return groupedNotifications;
        },
    },
    async mounted() {
        try {
            await Promise.all([
                this.$store.dispatch("meetings/meetings/getActionItems", {
                    payload: {},
                }),
                this.$store.dispatch("notifications/profilePreview/getMyNotifications"),
            ]);
        } finally {
            if (!this.groupedNotifications.todo?.length) {
                this.selectedTab = {
                    id: "news",
                };
            }
            this.isLoading = false;
        }
    },
};
</script>
